import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import classnames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import { Button, OverlayTrigger, Popover } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faListAlt } from '@fortawesome/free-solid-svg-icons';
const stopPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const ImportTable = ({ title, label, importableValues, isValueImported, currentValue, onImportValue, id })=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("h3", {
                children: [
                    title && /*#__PURE__*/ _jsx("div", {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("small", {
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("table", {
                className: "table table-responsive table-condensed",
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    className: "w-50",
                                    children: "Värde"
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    className: "w-25",
                                    children: "Källa"
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    className: "w-25 question__import-menu__button__col"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("tbody", {
                        children: importableValues.map((value)=>{
                            const currentlyImported = isValueImported && currentValue && currentValue === value.value;
                            return /*#__PURE__*/ _jsxs("tr", {
                                className: classnames({
                                    'question__is-imported': currentlyImported
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: value.text
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: value.source
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            bsSize: "xs",
                                            bsStyle: "success",
                                            icon: "file-import",
                                            disabled: currentlyImported,
                                            onClick: (e)=>{
                                                stopPropagation(e);
                                                onImportValue(value);
                                                document.body.click();
                                            },
                                            children: "Välj"
                                        })
                                    })
                                ]
                            }, `${id}_${value.value}_${value.source}`);
                        })
                    })
                ]
            })
        ]
    });
};
const ImportMenu = (props)=>{
    const { currentValue, importableValues, isValueImported, onImportValueChange } = props;
    const [id] = useState(uniqueId('Question_ImportMenu_'));
    const label = props.label;
    const group = importableValues[0]?.group;
    const importIcon = isValueImported ? /*#__PURE__*/ _jsx("div", {
        className: "d-flex align-items-center",
        children: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
            icon: faCheck,
            size: "lg",
            className: "ms-2 text-success",
            title: "Importerat värde"
        })
    }) : null;
    if (!importableValues || importableValues.length === 0 || importableValues.length === 1 && isValueImported) {
        return importIcon;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ _jsx(OverlayTrigger, {
                rootClose: true,
                trigger: [
                    'click'
                ],
                placement: "right",
                overlay: /*#__PURE__*/ _jsx(Popover, {
                    id: id,
                    className: "mw-100",
                    children: /*#__PURE__*/ _jsx(ImportTable, {
                        id: id,
                        title: group,
                        label: label,
                        importableValues: importableValues,
                        isValueImported: isValueImported,
                        currentValue: currentValue,
                        onImportValue: onImportValueChange
                    })
                }),
                children: /*#__PURE__*/ _jsx(Button, {
                    className: "question__import-button ms-2 text-primary",
                    onClick: stopPropagation,
                    icon: faListAlt,
                    bsStyle: "link",
                    title: "Visa alternativ för import"
                })
            }),
            importIcon
        ]
    });
};
export default ImportMenu;
